import { api } from './client';
import type { Organization, TeamMember, Invitation } from './types';

export const orgsApi = {
  list: () => api.get<{ organizations: Organization[] }>('/orgs'),
  get: (id: string) => api.get<{ organization: Organization }>(`/orgs/${id}`),
  create: (name: string) => api.post<{ organization: Organization }>('/orgs', { name }),
  update: (id: string, input: { name?: string }) => api.patch<{ organization: Organization }>(`/orgs/${id}`, input),
  delete: (id: string) => api.delete<{ message: string }>(`/orgs/${id}`),

  // Members
  getMembers: (orgId: string) => api.get<{ members: TeamMember[] }>(`/orgs/${orgId}/members`),
  updateMemberRole: (orgId: string, memberId: string, role: string) =>
    api.patch(`/orgs/${orgId}/members/${memberId}`, { role }),
  removeMember: (orgId: string, memberId: string) =>
    api.delete(`/orgs/${orgId}/members/${memberId}`),

  // Invitations
  getInvitations: (orgId: string) => api.get<{ invitations: Invitation[] }>(`/orgs/${orgId}/invitations`),
  invite: (orgId: string, email: string, role: string) =>
    api.post(`/orgs/${orgId}/invitations`, { email, role }),
  cancelInvitation: (orgId: string, invId: string) =>
    api.delete(`/orgs/${orgId}/invitations/${invId}`),

  // Accept/decline invitation
  acceptInvitation: (token: string) => api.post(`/invitations/${token}/accept`),
  declineInvitation: (token: string) => api.post(`/invitations/${token}/decline`),
};
